import React from "react";
import { Navigate } from "react-router-dom";
import { useAppSelector } from "features/store";

type ResetPasswordRouteProps = {
  children: JSX.Element;
};

const ResetPasswordRoute = ({ children }: ResetPasswordRouteProps) => {
  const { isAuthenticated, user } = useAppSelector((state) => state.auth);

  // If not authenticated, redirect to login
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // If authenticated but password reset is not required, redirect to home
  if (isAuthenticated && user && user.is_pass_reset) {
    return <Navigate to="/" replace />;
  }

  // Allow access if authenticated and password reset is required
  return children;
};

export default ResetPasswordRoute;
